<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

export default {
    init: (payload) => {
        payload.filter();
    },    
    methods:{
        filter() {

            if(this.truckerName) {
                alert('Selecione um caminhoneiro da lista para pesquisar');
                return;
            }

            const state = this;
            const queryParams = new URLSearchParams();
            
            for(const key in this.filters) {
                const value = this.filters[key];
                if(value != null)
                    queryParams.append(key, value);
            }
            this.form = {};
            this.getTotalUser();
            console.log('URL', Endpoints.reports.termsAccepted);
            Request.do(state, 'GET', Request.getDefaultHeader(state), { },
                `${Endpoints.reports.termsAccepted}?${queryParams.toString()}`,
                (response)=>{
                    //console.log('RESPONSE', response);
                    this.items = response;
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                    
                }
            );

        },
        selectItem(item) {            
            const data = JSON.parse(JSON.stringify(item));            
            this.form = {                
                systemUser: data._id,
                fullname: `${data.firstName} ${data.lastName}`,
                userType: data.company ? 'company' : 'systemUser',
                status: data.company ? data.company.status : data.status,
                companyUser: data.company ? data.company._id : null
            };
            window.scrollTo(0, 0);
        },
        saveStatus() {

            $('#spinner').modal('toggle');
            const formData = JSON.parse(JSON.stringify(this.form));
            const id = formData.userType === 'company' ? formData.companyUser : formData.systemUser;
            
            const state = this;
            Request.do(state, 'PUT', Request.getDefaultHeader(state), formData,
                `${Endpoints.reports.termsAccepted}/${id}`,
                (response)=>{
                    console.log('RESPONSE', response);
                    this.filter();
                    $('#spinner').modal('toggle');
                    alert('status alterado com sucesso');
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                    this.form = {};
                    $('#spinner').modal('toggle');                    
                }
            );

        },
        setPage(index) {
            this.filters.page = index;
        },
        fetchData(){
            this.csv_export.data = this.items;
            return this.csv_export.data;
        },
        getTotalUser() {

            const state = this;
            const queryParams = new URLSearchParams();
            
            for(const key in this.filters) {
                const value = this.filters[key];
                if(value != null)
                    queryParams.append(key, value);
            }
            queryParams.append('count', true);

            Request.do(state, 'GET', Request.getDefaultHeader(state), { },
                `${Endpoints.reports.termsAccepted}?${queryParams.toString()}`,
                (response)=>{  
                    
                    this.total = response.length > 0 ? response[0].total : 0;
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                    
                }
            );

        },
        onChangeName: function(input) {
            
            let state = this;
            this.truckerName = input;            
            
            if(input.length < 4) {
                this.truckerName = null;
                this.filters.systemUser = null;
                return [];
            }

            const { status, userType } = this.filters;
            return new Promise(
                (resolve, reject) => {

                    const url = userType === 'USER-COMPANY'
                        ? `${Endpoints.companies.suggest}?term=${input}&status=${status}`
                        : `${Endpoints.systemUsers.suggest}?term=${input}&status=${status}`;
                    
                    Request.do(state, 'GET', Request.getDefaultHeader(state), { }, 
                        url,
                        (response)=>{  
                            resolve(response);
                        },
                        (error)=>{//ERROR CALLBACK
                            
                            reject(error)
                        }
                    );

                }
            )

        },
        getResultValue(result) {
            const labels =  this.filters.userType === 'USER-COMPANY' ? result.fantasyName : `${result.firstName || ''} ${result.lastName || ''}`;
            return labels;
        },
        submitFilter: function(term) {            
            this.truckerName = null;
            this.filters.systemUser = term._id;
            this.filter();
        },
        changeUserType: function() {
            this.filters.systemUser = null;
            this.truckerName = null;
            setTimeout(() => this.filter(), 100);
        },
        getStatusLabel(status) {
            if(status.toUpperCase() === 'ACTIVE')
                return 'ATIVO';

            if(status.toUpperCase() === 'ARCHIVED')
                return 'ARQUIVADO';

            return status;

        },
        camelize: Common.camelize,
    }
}
</script>